import { z } from "zod";

import { baseApiResponse } from "./BaseApiResponse";

export const loyaltyLevelResolver = z.object({
	Coef: z.string(),
	ConfirmPoints: z.string(),
	Description: z.string(),
	Image: z.string(),
	Level: z.string(),
	Name: z.string(),
	NextLevelPoints: z.string()
});

export type LoyaltyLevelModel = z.infer<typeof loyaltyLevelResolver>;

export const listLoyaltyLevelsResult = baseApiResponse.omit({ data: true }).extend({
	data: z.record(loyaltyLevelResolver)
});

export type ListLoyaltyLevelsResult = z.infer<typeof listLoyaltyLevelsResult>;

export const loyaltyStoreCategoryResolver = z.object({
	ID: z.string(),
	Items: z.string(),
	Name: z.string(),
	Order: z.string(),
	Status: z.string()
});

export type LoyaltyStoreCategoryModel = z.infer<typeof loyaltyStoreCategoryResolver>;

export const loyaltyStoreResolver = z.object({
	AddDate: z.string(),
	AvailableForLevels: z.string(),
	Categories: z.array(z.any()),
	// CreditTournamentPoints: null,
	Description: z.string(),
	DisplayToAllLevels: z.string(),
	ID: z.string(),
	Image: z.string(),
	IsItemAvailable: z.string(),
	Name: z.string(),
	Order: z.string(),
	Price: z.object({
		LOYALTY: z.string(),
		EXPERIENCE: z.string(),
		EUR: z.string(),
		RUB: z.string(),
		USD: z.string()
	}),
	PriceType: z.string(),
	Quantity: z.string(),
	RepeatBuyRestriction: z.string(),
	Status: z.string(),
	Type: z.string(),
	TypePriceForBonus: z.string()
});

export type LoyaltyStoreModel = z.infer<typeof loyaltyStoreResolver>;

export const listLoyaltyStoresResult = baseApiResponse.omit({ data: true }).extend({
	data: z.object({
		Categories: loyaltyStoreCategoryResolver.array(),
		Items: loyaltyStoreResolver.array()
	})
});

export type ListLoyaltyStoresResult = z.infer<typeof listLoyaltyStoresResult>;
